import { Injectable } from '@angular/core';

export type ProductGroupViewMode = 'tile' | 'list';

@Injectable({ providedIn: 'root' })
export class ProductGroupViewPreferenceService {
    private readonly storageKey = 'productGroupViewMode';

    getViewMode(): ProductGroupViewMode {
        return localStorage.getItem(this.storageKey) === 'list' ? 'list' : 'tile';
    }

    setViewMode(mode: ProductGroupViewMode): void {
        localStorage.setItem(this.storageKey, mode);
    }
}
